import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, FormGroup, Form } from 'reactstrap';
import InputGroup from '../../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../../components/cms/form/submitButtons';

const twoCols = { xs: 12, md: 6 };

const Item = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  tab,
  isSubmitting,
  isSubmittingRedirect,
  imageSrc,
  searchCompany,
  onChangeCompanyInput,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-money pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Form onSubmit={onSubmit(true)}>
              <Row>
                <Col md={9}>
                  <InputGroup
                    name="description"
                    label={t('Description')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.description}
                    icon="fa fa-star"
                  />
                  <InputGroup
                    name="amount"
                    label={t('Amount')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.amount}
                    icon="fa fa-money"
                  />
                  <FormGroup row className="my-0">
                    <Col {...twoCols}>

                    </Col>
                    <Col {...twoCols}>

                    </Col>
                  </FormGroup>
                </Col>
                <Col md={3}>

                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <SubmitButtons
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                    showApplyButton={false}
                    isSubmittingRedirect={isSubmittingRedirect}
                  />
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Item.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string.isRequired,
};

export default Item;



// WEBPACK FOOTER //
// ./src/views/companies/tokensBalance/item/Item.jsx